import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '../../../appshared/invoice/item/item.service';
import { TranslateService } from '@ngx-translate/core';
import { CartService } from '../../../appshared/invoice/cart.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { ItemModule, ViewItem } from '../../../appshared/invoice/item/item.module';
import { AppLoaderService } from '../../../common/service/app-loader/app-loader.service';
import { CategoryService } from '../../../appshared/masters/category/category.service';
import { CategoryModule } from '../../../appshared/masters/category/category.module';

@Component({
    selector: 'app-shop',
    templateUrl: './shop.component.html',
    styleUrls: ['./shop.component.scss']
})
export class ShopComponent {

    public SelectedLanguage: string = "en";
    private sub: any;
    closeModal: any;
    public apiURL: string = "";
    ComID: number = 2;

    constructor(
        public router: Router, private serv: CategoryService, private route: ActivatedRoute, private servItem: ItemService, private loader: AppLoaderService, public translate: TranslateService,

        private cartService: CartService, private toastr: ToastrService
    ) {
        if (this.translate.currentLang != undefined) {

            this.SelectedLanguage = this.translate.currentLang;
        }

    }
    imgTitle: string = 'assets/img/page-title1.jpg';
    ngOnInit(): void {

        this.route.params.subscribe(params => {
            /*    if (+params['catID'] > 0) {*/
            try {
                this.Cid = +params['catID'];
                if (this.Cid.toString() == 'NaN') {
                    this.Cid = 0;
                }

            } catch (e) {
                this.Cid = 0;
                this.CategoryName = "";
            }
            try {
                this.SCid = +params['scatID'];
                if (this.SCid.toString() == 'NaN') {
                    this.SCid = 0;
                }

            } catch (e) {
                this.SCid = 0;
                this.CategoryName = "";
            }

            try {
                this.Tid = +params['tagId'];
                if (this.Tid.toString() == 'NaN') {
                    this.Tid = 0;
                }

            } catch (e) {
                this.Tid = 0;
                this.CategoryName = "";
            }


            try {
                this.serachName = params['serachName'];
                if (this.serachName.toString() == 'NaN') {
                    this.serachName = "";
                }

            } catch (e) {
                this.serachName = "";
            }

            if (this.Cid != 0) {
                this.FillCategory();
            }
            if (this.SCid != 0) {
                this.FillSubCategory();
            }

            if (this.Tid > 0) {

                this.fillTagItems();
            }
            else {

                this.fillItems();
            }
        });

        this.apiURL = environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/Items/';
        // this.FillCategory();
    }


    sortType: string = "Default";
    Tid: number = 0;
    Cid: number = 0;
    SCid: number = 0;
    CategoryName?: string = "";
    serachName?: string = "";

    currentDate = new Date();


    public dataSourceItems = new MatTableDataSource<ItemModule>();

    datas: any;

    FillCategory() {
        // this.loader.open();
        this.serv.getServiceID(this.Cid, this.ComID)
            .subscribe((res: CategoryModule[]) => {

                this.datas = res;

                if (this.datas.photoPath != '') {
                    this.imgTitle = environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/GnAtt/' + this.datas.photoPath;
                }

                if (this.SelectedLanguage != "en") {

                    this.CategoryName = this.datas.nameAr;
                }
                else {

                    this.CategoryName = this.datas.name;
                }

                //this.loader.close();
            },
                (err: any) => {
                    //this.loader.close();
                    console.log(err);
                });
    }

    FillSubCategory() {
        // this.loader.open();
        this.serv.getServiceID(this.SCid, this.ComID)
            .subscribe((res: CategoryModule[]) => {

                this.datas = res;

                if (this.datas.photoPath != '') {
                    this.imgTitle = environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/GnAtt/' + this.datas.photoPath;
                }

                if (this.SelectedLanguage != "en") {

                    this.CategoryName = this.datas.nameAr;
                }
                else {

                    this.CategoryName = this.datas.name;
                }

                //this.loader.close();
            },
                (err: any) => {
                    //this.loader.close();
                    console.log(err);
                });
    }

    //////////////////////////////////////////


    onSortChange(event: any) {
        this.sortType = event.target.value;
        this.fillItems();
    }

    fillItems() {
        this.dataSourceItems = new MatTableDataSource<ItemModule>();
        this.loader.open();
        this.servItem.getService(this.ComID, this.Cid, this.SCid, this.serachName, this.sortType)
            .subscribe((res: ItemModule[]) => {
                this.loader.close();

                for (var i = 0; i < res.length; i++) {
                    res[i].webDiscountFromDate = new Date(res[i].webDiscountFromDate);
                    res[i].webDiscountToDate = new Date(res[i].webDiscountToDate);

                    res[i].newArrivalFromDate = new Date(res[i].newArrivalFromDate);
                    res[i].newArrivalToDate = new Date(res[i].newArrivalToDate);
                }

                this.dataSourceItems.data = res;


            },
                (err: any) => {
                    this.loader.close();
                    console.log(err);
                });
    }

    fillTagItems() {
        this.dataSourceItems = new MatTableDataSource<ItemModule>();
        this.loader.open();
        this.servItem.getServiceTag(this.ComID, this.Tid, this.sortType)
            .subscribe((res: ItemModule[]) => {
                this.loader.close();

                for (var i = 0; i < res.length; i++) {
                    res[i].webDiscountFromDate = new Date(res[i].webDiscountFromDate);
                    res[i].webDiscountToDate = new Date(res[i].webDiscountToDate);

                    res[i].newArrivalFromDate = new Date(res[i].newArrivalFromDate);
                    res[i].newArrivalToDate = new Date(res[i].newArrivalToDate);
                }

                this.dataSourceItems.data = res;


            },
                (err: any) => {
                    this.loader.close();
                    console.log(err);
                });
    }
    onCategoryChange(catID: number, CatName: string | undefined, CatNameAr: string | undefined) {

        this.Cid = catID;

        if (this.SelectedLanguage != "en") {

            this.CategoryName = CatNameAr;
        }
        else {

            this.CategoryName = CatName;
        }

        this.fillItems();
    }




    addToCart(itemM: ItemModule) {


        this.loader.open();

        var price = itemM.salesPrice;
        if (itemM.activateWebDiscount && itemM.webDiscountFromDate < new Date() && itemM.webDiscountToDate > new Date()) {
            price = itemM.webDiscountAmount;
        }


        var product: ViewItem = {


            inItemID: itemM.inItemID,
            name: itemM.webNameEn,
            nameAr: itemM.webNameAr,
            salesPrice: itemM.salesPrice,
            barcode: itemM.barcode,
            inCategoryID: itemM.inCategoryID,
            description: itemM.description,
            inUnitID: itemM.inUnitID,
            photoPath: itemM.photoPath,
            itemCode: itemM.itemCode,
            unitName: itemM.unitName,
            systemCode: itemM.systemCode,
            categoryNameAr: itemM.categoryNameAr,
            descriptionAr: itemM.descriptionAr,
            categoryName: itemM.categoryName,

            saleTaxPercentage: itemM.saleTaxPercentage,
            isViewWeb: itemM.isViewWeb,
            webDiscountFromDate: itemM.webDiscountFromDate,
            webDiscountToDate: itemM.webDiscountToDate,
            webDiscountAmount: itemM.webDiscountAmount,
            activateWebDiscount: itemM.activateWebDiscount,
            unitNameAr: itemM.unitNameAr,
            webDiscountPercentage: itemM.webDiscountPercentage,
            wholesalePrice: itemM.webDiscountPercentage,

            cartQuantity: 1,
            cartPrice: price

        };



        this.cartService.addToCart(product, 1);

        this.loader.close();

        var transR = this.translate.instant('Your_product_added_to_the_cart');
        this.toastr.success(transR, '');


    }



    onClickItem(ItemId: number) {
        this.router.navigate(['product-details', { ItemId: ItemId }]);
    }

    onPageClick(event) {
        window.scroll(0, 0);

        this.currPages = event;
    }

    currPages: number = 1;

    shopFullWidth: number = 4;

    onClickNextItem(currentIndex: number) {
        const nextIndex = currentIndex + 1;
        const nextItemId = this.dataSourceItems.data[nextIndex].inItemID;
        this.router.navigate(['product-details', { ItemId: nextItemId }]);
    }
    getNextImage(currentIndex: number): string | null {
        const nextIndex = currentIndex + 1;
        if (nextIndex < this.dataSourceItems.data.length) {
            return this.apiURL + this.dataSourceItems.data[nextIndex].photoPath;
        }
        return null; // No next image
    }

    onClickAfterNextItem(currentIndex: number) {
        const afterNextIndex = currentIndex + 2;
        const AfternextItemId = this.dataSourceItems.data[afterNextIndex].inItemID;
        this.router.navigate(['product-details', { ItemId: AfternextItemId }]);
    }
    getAfterNextImage(currentIndex: number): string | null {
        const afterNextIndex = currentIndex + 2;
        if (afterNextIndex < this.dataSourceItems.data.length) {
            return this.apiURL + this.dataSourceItems.data[afterNextIndex].photoPath;
        }
        return null; // No after next image
    }


    onClickAfterAfterNextItem(currentIndex: number) {
        const afterAfterNextIndex = currentIndex + 3;
        const AfterAfternextItemId = this.dataSourceItems.data[afterAfterNextIndex].inItemID;
        this.router.navigate(['product-details', { ItemId: AfterAfternextItemId }]);
    }
    getAfterAfterNextImage(currentIndex: number): string | null {
        const afterAfterNextIndex = currentIndex + 3;
        if (afterAfterNextIndex < this.dataSourceItems.data.length) {
            return this.apiURL + this.dataSourceItems.data[afterAfterNextIndex].photoPath;
        }
        return null; // No after after next image
    }
}
